import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import { getRateCardHistory } from "../../api/commands/ledger";

export const Message = defineMessageUnion({
	CompletedFetchHistory: {
		asOf: S.Option(S.String),
		generation: S.Number,
		result: getRateCardHistory.Result,
	},
});
export type Message = typeof Message.Type;
